import React, { useEffect, useRef } from "react";
import { Link, NavLink, Prompt, useLocation } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import { translate } from "../_artifact/i18n/Artifacti18n";
import { trackingLog } from "./modules/Tracking/_redux/tracking";
import { format } from "date-fns";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
function Navbar({ intl }) {
  const location = useLocation();
  const { state } = useSelector((state) => ({ state }), shallowEqual);
  const user = state?.auth?.user;
  const history = useHistory();
  const isMountedRef = useRef(true);

  const handleBackButton = (e) => {
    if (
      location.pathname === "/testing/questionnaire" ||
      location.pathname === "/testing/timerstart" ||
      location.pathname === "/testing/cameras/post" ||
      location.pathname === "/testing/finish" ||
      location.pathname === "/testing/postfeed-questionnaire"
    ) {
      e.preventDefault();
      const confirmed = window.confirm(
        translate("TESTING.WARNING.MISSED_TEST", intl)
      );
      if (confirmed) {
        isMountedRef.current = false; // prevent double push
        history.push("/home"); // navigate to home
      } else {
        // stay on the same page
        window.history.pushState(null, "", window.location.pathname);
      }
    }
  };
  useEffect(() => {
    if (
      location.pathname === "/testing/questionnaire" ||
      location.pathname === "/testing/timerstart" ||
      location.pathname === "/testing/cameras/post" ||
      location.pathname === "/testing/finish" ||
      location.pathname === "/testing/postfeed-questionnaire"
    ) {
      window.history.pushState(null, "", window.location.pathname); // fake entry
      window.addEventListener("popstate", handleBackButton);
    }
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [location.pathname, history]);

  const handleHomeClick = (e) => {
    if (
      location.pathname === "/testing/questionnaire" ||
      location.pathname === "/testing/timerstart" ||
      location.pathname === "/testing/cameras/post" ||
      location.pathname === "/testing/finish" ||
      location.pathname === "/testing/postfeed-questionnaire"
    ) {
      e.preventDefault();
      const confirmed = window.confirm(
        translate("TESTING.WARNING.MISSED_TEST", intl)
      );
      if (confirmed) {
        history.push("/home");
      }
    }
  };
  return (
    <header className="header">
      <div className="header-inner">
        <div className="logo desktop-only">
          <Link to="/">
            {/* <img src="/assets/images/logo.svg" alt="logo" /> */}
            <img src="/assets/images/cih_logo.png" width="40" alt="" />
          </Link>
        </div>
        <ul className="nav">
          <li>
            <NavLink to="/home" onClick={handleHomeClick}>
              <i className="icon-test mobile-only"></i>
              <span>{translate("APP.GENERAL.HOME", intl)}</span>
            </NavLink>
          </li>
          <li className="desktop-only">
            <NavLink to="/testing" onClick={handleHomeClick}>
              <i className="icon-test mobile-only"></i>
              <span>{translate("TESTING.GENERAL.TEST", intl)}</span>
            </NavLink>
          </li>
          {/* <li>
            <NavLink to="/rewards">
              <i className="icon-rewards mobile-only"></i>
              <span>{translate("REWARDS.GENERAL.REWARDS", intl)}</span>
            </NavLink>
          </li> */}
          <li>
            <NavLink to="/support" onClick={handleHomeClick}>
              <i className="icon-chat mobile-only"></i>
              <span>{translate("SUPPORT.GENERAL.SUPPORT", intl)}</span>
            </NavLink>
          </li>
          <li className="mobile-only">
            <NavLink to="/profile" onClick={handleHomeClick}>
              <i className="icon-profile mobile-only"></i>
              <span>{translate("PROFILE.GENERAL.PROFILE", intl)}</span>
            </NavLink>
          </li>
          <li className="desktop-only">
            <NavLink to="/profile" onClick={handleHomeClick}>
              <span className="profile">
                {user?.first_name?.[0]?.toUpperCase()}
              </span>
            </NavLink>
          </li>
        </ul>
      </div>
    </header>
  );
}
export default injectIntl(Navbar);
